/* eslint-disable react-hooks/exhaustive-deps */
import { EuiBadge, EuiButton, EuiPageHeader, EuiSpacer } from "@elastic/eui";
import i18n from "i18n-js";
import { FC, useEffect, useState } from "react";
import { RootStateOrAny, useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  CustomizeFilter,
  CustomizeTablePagination,
  DeleteAction,
  EditAction,
  FilterInput,
  Access
} from "../../../components";
import { Paths, PERMISSIONS } from "../../../constants";
import {
  archiveManyRoom,
  deleteManyRoom,
  deleteOneRoom,
  getListRoom,
  unarchiveManyRoom,
} from "../../../redux/actions/room";
import { getInitParams, formatToLocalDate } from "../../../utils";

const List: FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [params, setParams] = useState(getInitParams());

  useEffect(() => {
    dispatch(getListRoom(params));
  }, [params]);

  const { rooms, total } = useSelector(
    (state: RootStateOrAny) => state.room.list
  );
  const { isLoadingRequest } = useSelector(
    (state: RootStateOrAny) => state.room
  );

  const onChangePage = (value: any) => {
    setParams({ ...params, offset: value });
  };

  const onDeleteMany = (ids: string[]) => {
    dispatch(deleteManyRoom({ ids }));
  };

  const onArchiveMany = (ids: string[]) => {
    dispatch(archiveManyRoom({ ids, isArchived: true }));
  };

  const onUnarchiveMany = (ids: string[]) => {
    dispatch(unarchiveManyRoom({ ids, isArchived: false }));
  };

  const columns = [
    {
      field: "code",
      name: "Mã lớp",
      sortable: false,
    },
    {
      field: "maxQuantity",
      name: "Sĩ số tối đa",
    },
    // {
    //   field: "isArchived",
    //   name: "Lưu trữ",
    //   sortable: false,
    //   width: 120,
    //   render: (isArchived: boolean) => (
    //     <EuiBadge color={isArchived ? "warning" : "ghost"}>
    //       {isArchived ? "Đã lưu trữ" : "Không"}
    //     </EuiBadge>
    //   ),
    // },
    // {
    //   field: "createdBy",
    //   name: "Tạo bởi",
    //   sortable: false,
    // },
    {
      field: "createdAt",
      name: "Khởi tạo",
      render: (time: string) => <p>{formatToLocalDate(time)}</p>,
    },
    {
      field: "updatedAt",
      name: "Cập nhật",
      render: (time: string) => <p>{formatToLocalDate(time)}</p>,
    },
    {
      name: "Hành động",
      actions: [
        {
          render: (item: any) => {
            return (
              <Access permissionKey={PERMISSIONS.ROOM_UPDATE} >
                <EditAction link={Paths.ROOM.EDIT.replace(":id", item._id)} />
              </Access>
            );
          },
        },
        {
          render: (item: any) => {
            return (
              <Access permissionKey={PERMISSIONS.ROOM_DELETE} >
              <DeleteAction
                onOk={() => {
                  dispatch(deleteOneRoom({ id: item._id }));
                }}
              />
              </Access>
            );
          },
        },
      ],
    },
  ];

  const onChangeItemsPerPage = (per: any) => {
    setParams({ ...params, limit: per });
  };

  const filterInputs: FilterInput[] = [
    { name: "code", label: "Mã lớp học", type: "input", visible: true },
    {
      name: "isArchived",
      label: "Lưu trữ",
      type: "select",
      options: [
        { value: "", text: "Tất cả" },
        { value: "true", text: "Đã lưu trữ" },
        { value: "false", text: "Không" },
      ],
    },
  ];

  const onFilter = (data: any) => {
    const newFilter: any = { ...params, ...data };
    for (let key in newFilter) {
      if (newFilter[key] === "" || newFilter[key] === undefined) {
        delete newFilter[key];
      }
    }
    setParams({ ...newFilter, offset: 0 });

    // setParams(newFilter);
  };

  return (
    <>
      <EuiPageHeader
        bottomBorder
        className="mtb-page-header"
        pageTitle="Quản lý lớp học"
        rightSideItems={[
          <Access permissionKey={PERMISSIONS.ROOM_CREATE} >
            <EuiButton
              iconSide="left"
              iconType="plusInCircle"
              fill
              onClick={() => navigate({ pathname: Paths.ROOM.CREATE })}
            >
              {i18n.t("common.createButton")}
            </EuiButton>
          </Access>
        ]}
      />
      <EuiSpacer size="s" />

      <CustomizeFilter
        list={filterInputs}
        onFilter={onFilter}
        page={Paths.ROOM.LIST}
      />

      <EuiSpacer size="s" />

      <CustomizeTablePagination
        columns={columns}
        body={rooms}
        isLoading={isLoadingRequest}
        pagination={params}
        total={total}
        isSelectable={true}
        onChangePage={onChangePage}
        onChangeItemsPerPage={onChangeItemsPerPage}
        onDeleteMany={onDeleteMany}
        onArchiveMany={onArchiveMany}
        onUnarchiveMany={onUnarchiveMany}
      />
    </>
  );
};

export default List;
